import { useQuery } from "@tanstack/react-query";

import { getSystemStatus } from "../api";

const QUERY_KEY = "system-status";
const STALE_TIME = 5 * 60 * 1000;

function useSystemStatus() {
  const query = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: ({ signal }) => getSystemStatus(signal),
    staleTime: STALE_TIME,
  });

  return {
    status: query.data?.status,
    pageUrl: query.data?.page.url,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export { useSystemStatus };
